import { Routes } from '@angular/router';
import { AppShell } from './core/layout/shell/app-shell';
import { authGuard } from './core/auth/auth.guard';
import { ROUTE_PATHS } from './core/routing/route-paths';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'namespaces',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    component: AppShell,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        redirectTo: 'namespaces',
      },
      {
        path: 'namespaces',
        loadComponent: () =>
          import('./features/namespaces/presentation/pages/namespaces-page').then(
            (m) => m.NamespacesPage
          ),
      },
      {
        path: 'databases/:ns',
        loadComponent: () =>
          import('./features/databases/presentation/pages/databases-page').then(
            (m) => m.DatabasesPage
          ),
      },
      {
        path: 'db-users/:ns',
        loadComponent: () =>
          import('./features/db-users/presentation/pages/db-users-page').then(
            (m) => m.DbUsersPage
          ),
      },
      { path: '**', redirectTo: 'namespaces' },
    ],
  },
  {
    path: '**',
    redirectTo: ROUTE_PATHS.LOGIN,
  },
];
